import {
  Modal as ChakraModal,
  ModalBodyProps as ChakraModalBodyProps,
  ModalContentProps as ChakraModalContentProps,
  ModalProps as ChakraModalProps,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import * as React from 'react';

interface ModalProps extends ChakraModalProps {
  title?: string | React.ReactNode;
  hasCloseButton?: boolean;
  contentProps?: ChakraModalContentProps;
  bodyProps?: ChakraModalBodyProps & { ref?: React.RefObject<HTMLDivElement> };
  footer?: React.ReactNode;
  footerJustifyContent?: string;
  isCenteredProps?: boolean;
  modalCloseButtonSize?: string;
}

const Modal: React.FC<ModalProps> = ({
  children,
  title,
  hasCloseButton = true,
  contentProps,
  bodyProps,
  footer,
  footerJustifyContent,
  isCenteredProps,
  modalCloseButtonSize,
  ...rest
}) => (
  <ChakraModal isCentered={isCenteredProps ?? true} {...rest}>
    <ModalOverlay />
    <ModalContent {...contentProps}>
      {title && (
        <ModalHeader
          backgroundColor="#f8f8f8"
          fontWeight="bold"
          color="gray.700"
          as="h2"
          borderBottom="1px solid #dee2e6"
          borderTopLeftRadius="md"
          borderTopRightRadius="md"
          pt={title === 'Delete assessment' ? 10 : 4}
        >
          {title !== 'Delete assessment' && title}
        </ModalHeader>
      )}

      {hasCloseButton && (
        <ModalCloseButton
          zIndex={4}
          top="15px"
          {...(modalCloseButtonSize ? { size: modalCloseButtonSize } : {})}
        />
      )}

      <ModalBody
        py={6}
        maxH="calc(100vh - 200px)"
        position="relative"
        overflow="auto"
        {...bodyProps}
      >
        {children}
      </ModalBody>

      {footer && (
        <ModalFooter
          borderTop="1px solid transparent"
          borderColor="gray.200"
          justifyContent={
            footerJustifyContent ? footerJustifyContent : 'flex-end'
          }
        >
          {footer}
        </ModalFooter>
      )}
    </ModalContent>
  </ChakraModal>
);
export default Modal;
